import { render, staticRenderFns } from "./Bezel.vue?vue&type=template&id=df7de0f2&lang=pug&"
import script from "./Bezel.vue?vue&type=script&lang=ts&"
export * from "./Bezel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Bezel.vue"
export default component.exports